import { render } from "./PromotionConflictModal.vue?vue&type=template&id=27abdb5c&scoped=true"
import script from "./PromotionConflictModal.vue?vue&type=script&lang=js"
export * from "./PromotionConflictModal.vue?vue&type=script&lang=js"

import "./PromotionConflictModal.vue?vue&type=style&index=0&id=27abdb5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27abdb5c"]])

export default __exports__